import { useRef } from 'react';
import type { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';
import { useChatStore } from '../hooks/useChatStore';
import { ChatEmptyState } from './ChatEmptyState';
import { ChatHistory } from './ChatHistory';
import { ChatHeader } from './ChatHeader';
import { ChatInput } from './ChatInput';
import { ChatMessages } from './ChatMessages';
import { ChatResizeHandle } from './ChatResizeHandle';

export function ChatPanel() {
  const { t } = useTranslation();
  const hasMessages = useChatStore((state) => state.messages.length > 0);
  const isHistoryOpen = useChatStore((state) => state.isHistoryOpen);
  const panelWidth = useChatStore((state) => state.panelWidth);
  const scrollRef = useRef<HTMLDivElement>(null);

  return (
    <aside
      aria-label={t('domain.ai.chat.title')}
      style={{ '--chat-width': `${panelWidth}px` } as CSSProperties}
      className="flex h-full w-[var(--chat-width)] shrink-0 flex-col gap-2 border-l border-neutrals-v2-300 bg-backgrounds-primary px-4 pt-3 pb-4 max-md:fixed max-md:inset-0 max-md:z-50 max-md:w-full md:relative md:max-w-[50vw]">
      <ChatResizeHandle />
      <ChatHeader />
      {isHistoryOpen ? (
        <ChatHistory />
      ) : (
        <>
          <div
            ref={scrollRef}
            className="flex min-h-0 flex-1 flex-col overflow-y-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
            {hasMessages ? (
              <ChatMessages scrollRef={scrollRef} />
            ) : (
              <ChatEmptyState />
            )}
          </div>
          <ChatInput />
        </>
      )}
    </aside>
  );
}
